module.exports = __webpack_public_path__ + "img/pre_filtrage_invest.19fca6db.jpg";